import React, { Fragment } from 'react';
import FormField from '../swedish-private-v2/form-field';
import { Heading } from '../../common/form/form-parts';

export const ManualPersonalDetails = (props) => {
    const { form } = props;
    return (
        <Fragment>
            <Heading>Personuppgifter</Heading>
            <div className="d-flex w-100 mb-1">
                <FormField
                    containerClassName="flex-grow-1 mr-2"
                    form={form}
                    field="FirstName"
                    placeholder="Förnamn"
                />
                <FormField
                    containerClassName="flex-grow-1"
                    form={form}
                    field="LastName"
                    placeholder="Efternamn"
                />
            </div>
            <FormField
                containerClassName="mb-1"
                form={form}
                field="StreetName"
                placeholder="Gatuadress"
            />
            <div className="d-flex w-100 mb-1">
                <FormField
                    containerClassName="flex-grow-1 mr-2"
                    form={form}
                    field="ZipCode"
                    placeholder="Postnummer"
                    type="tel"
                />
                <FormField
                    containerClassName="flex-grow-1"
                    form={form}
                    field="Town"
                    placeholder="Ort"
                />
            </div>
            <FormField
                type="tel"
                containerClassName="mb-3"
                form={form}
                field="PhoneNumber"
                placeholder="Ditt mobilnummer"
                hint="Ditt telefonnummer behövs ifall du skulle behöva återställa ditt lösenord."
            />
        </Fragment>
    );
};
